import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isRun: true,
  isRunning: true,
  steps: [],
  currentStepIndex: 0,
  hasSeen: false,
  nameTour: null,
};

const guideTourSlice = createSlice({
  name: "guideTour",
  initialState,
  reducers: {
    logTourState: (state) => {
      console.log("🧪 Current tour state in reducer:", state);
      // console.log("🧪 Current tour state:", structuredClone(state));
    },
    setNameTour: (state, action) => {
      state.nameTour = action.payload;
    },
    startTour: (state, action) => {
      console.log("startTour => ", { steps: action.payload })
      state.isRunning = true;
      state.steps = action.payload || [];
      state.currentStepIndex = 0;
      state.hasSeen = false;
    },
    stopTour: (state) => {
      console.log("stopTour")
      state.isRunning = false;
      state.steps = [];
    },
    stopAllTour: (state) => {
      console.log("stopAllTour")
      state.isRunning = false;
      state.isRun = false;
      state.steps = [];
    },
    resetGuideTour: (state) => {
      console.log("resetGuideTour");
      // state.isResetGuideTour = true;
      state.isRun = true;
      state.isRunning = true;
      state.steps = [];
      // state.currentStepIndex = 0;
      // state.hasSeen = false;
    }
  },
});

// export const {logTourState,startTour, stopTour, nextStep, markTourSeen } = guideTourSlice.actions;
export const { logTourState, stopTour, stopAllTour, resetGuideTour, startTour, setNameTour } = guideTourSlice.actions;
export default guideTourSlice.reducer;
